export default __webpack_public_path__ + "static/media/Silver_Book_C3_1 (1).50999ce5.png";